// The number of milliseconds in one day
const ONE_DAY = 1000 * 60 * 60 * 24;

export const countNumbersInPhoneMask = (phoneMask: string) =>
    phoneMask.split('').filter((maskItem) => maskItem === '.').length;

export const getDaysBetweenDates = (startDate: Date, endDate: Date) =>
    Math.round(Math.abs(endDate.getTime() - startDate.getTime()) / ONE_DAY);
